<div class="optional-address-lines" [formGroup]="formGroup()">
  @if (!expanded()) {
    <puro-button
      class="optional-address-lines__expand"
      type="button"
      variant="link"
      [attr.aria-expanded]="false"
      (buttonClick)="onExpandAddressLines()"
    >
      {{ 'createShipment.actions.addAddressLines' | translate }}
    </puro-button>
  }

  @if (expanded()) {
    <puro-input
      class="optional-address-lines__line2"
      [label]="addressLine2LabelKey() | translate"
      formControlName="addressLine2"
      [name]="avsFieldName('addressLine2')"
      appDisableBrowserAutofill="disabled"
      [fullWidth]="true"
      [error]="!!fieldError('addressLine2')"
      [errorMessage]="fieldError('addressLine2') ?? ''"
      (focusout)="onFieldBlur('addressLine2')"
    />

    <puro-input
      class="optional-address-lines__line3"
      [label]="'createShipment.fields.addressLine3' | translate"
      formControlName="addressLine3"
      [fullWidth]="true"
      [error]="!!fieldError('addressLine3')"
      [errorMessage]="fieldError('addressLine3') ?? ''"
      (focusout)="onFieldBlur('addressLine3')"
    />
  }
</div>
